export const socialLinks = [
  {
    id: 1,
    name: "website",
    icon: "globe",
    url: "http://Godstime-portfolio.netlify.app/",
  },
  {
    id: 2,
    name: "Twitter",
    icon: "twitter",
    url: "https://x.com/gt2025j",
  },
  {
    id: 3,
    name: "LinkedIn",
    icon: "linkedin",
    url: "https://www.linkedin.com/in/audu-godstime/",
  },
];
